import { T } from '@/i18n/LocaleProvider';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

/* Enlace "ver más" del sistema: una frase corta en gris + el link en negrita
   con flecha. Patrón único del sitio (ej. "Cada señal es auditable. Ver casos →").
   `external` usa OpenInNew icon + target/rel; interno usa →. Server-safe (component="a"). */
export default function MoreLink({
  text,
  href,
  external = false,
  children,
  sx,
}) {
  return (
    <Typography
      sx={{ fontSize: '13px', lineHeight: 1.7, color: 'text.muted', ...sx }}
    >
      <T>{text ? `${text} ` : ''}</T> <br />
      <Box
        component="a"
        href={href}
        {...(external && { target: '_blank', rel: 'noopener noreferrer' })}
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '3px',
          color: 'text.accent',
          fontWeight: 600,
          textDecoration: 'none',
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        <T>{children}</T>
        <T> </T>
        <T>
          {external ? (
            <OpenInNewIcon sx={{ fontSize: '13px' }} aria-hidden="true" />
          ) : (
            <Box component="span" aria-hidden="true">
              →
            </Box>
          )}
        </T>
      </Box>
    </Typography>
  );
}
